import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Reorder } from "@mui/icons-material";
import CustomCheckbox from "../customComponent/CustomCheckbox";

function ChoiceVerification(data) {
  const [selectedRows, setSelectedRows] = useState();
  const [idsFunction, setIdsFunction] = useState();
  const [rowData, setRowData] = useState();
  function createData(
    verify,
    id,
    name,
    university,
    course,
    intake,
    tutionFee,
    requestedDate
  ) {
    return {
      verify,
      id,
      name,
      university,
      course,
      intake,
      tutionFee,
      requestedDate
    };
  }

  useEffect(() => {
    setRowData(data?.rows);
    console.log(2343, rowData);
  });

  const rows = [
    createData(
      false,
      "2654566",
      "Shabeer Muhammed",
      "Cranfield University",
      "Global Public Health",
      "Jan, 2023",
      "25250",
      "15 / 02 / 2023"
    ),
    createData(
      false,
      "2654566",
      "Shabeer Muhammed",
      "Cranfield University",
      "Global Public Health",
      "Jan, 2023",
      "25250",
      "15 / 02 / 2023"
    ),
    createData(
      false,
      "2654566",
      "Shabeer Muhammed",
      "Cranfield University",
      "Global Public Health",
      "Jan, 2023",
      "25250",
      "15 / 02 / 2023"
    ),
    createData(
      false,
      "2654566",
      "Shabeer Muhammed",
      "Cranfield University",
      "Global Public Health",
      "Jan, 2023",
      "25250",
      "15 / 02 / 2023"
    ),
    createData(
      false,
      "2654566",
      "Shabeer Muhammed",
      "Cranfield University",
      "Global Public Health",
      "Jan, 2023",
      "25250",
      "15 / 02 / 2023"
    )
  ];

  const handleSelectRow = (rowId) => {
    let updatedSelectedRows;
    if (selectedRows.includes(rowId)) {
      updatedSelectedRows = selectedRows.filter((id) => id !== rowId);
      setSelectedRows(selectedRows.filter((id) => id !== rowId));
    } else {
      updatedSelectedRows = [...selectedRows, rowId];
      setSelectedRows(updatedSelectedRows);
    }
    setIdsFunction(updatedSelectedRows);
  };

  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "scroll",
        "&::-webkit-scrollbar": {
          display: "none"
        }
      }}
    >
      <Table
        sx={{
          "& .MuiTableCell-root": {
            borderBottom: "1px solid rgba(220, 223, 227, 0.50)"
          }
        }}
      >
        <TableHead
          sx={{
            background: "#F9F9FB",
            "& th": {
              textTransform: "uppercase",
              fontWeight: "600",
              fontFamily: "Inter",
              color: "#666E7D"
            }
          }}
        >
          <TableRow>
            <TableCell>Verify</TableCell>
            <TableCell>Student ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Mobile</TableCell>
            <TableCell>Passport Number</TableCell>
            <TableCell>Lead Owner</TableCell>
            <TableCell>Branch Owner</TableCell>
            <TableCell>University</TableCell>
            <TableCell>Course</TableCell>
            <TableCell>Intake</TableCell>
            <TableCell>Tuition fee</TableCell>
            <TableCell>Application Started</TableCell>
            <TableCell>Offer Letter Received</TableCell>
            <TableCell>Visa Received</TableCell>

            <TableCell>{""}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            background: "#fff",
            border: "1px solid rgba(220, 223, 227, 0.50)"
          }}
        >
          {rowData?.map((row, i) => (
            <TableRow key={i}>
              <TableCell>
                {" "}
                <CustomCheckbox
                  value={row.verify}
                  handleChange={() => handleSelectRow(i)}
                />
              </TableCell>
              <TableCell>{row?.id}</TableCell>
              <TableCell>{row?.lead?.firstName}</TableCell>
              <TableCell>{row?.lead?.email}</TableCell>
              <TableCell>{row?.lead?.mobileNumber}</TableCell>
              <TableCell>
                {row?.lead?.lead_personal_details[0]?.passportNumber}
              </TableCell>
              <TableCell>{row?.lead?.leadOwnerName}</TableCell>
              <TableCell>{row?.user?.firstName}</TableCell>
              <TableCell>{row?.universityName}</TableCell>
              <TableCell>{row?.courseName}</TableCell>
              <TableCell>{row?.intakeDate}</TableCell>
              <TableCell>{row?.universityInternationalFee}</TableCell>
              <TableCell>{row?.createdAt?.split("T")[0]}</TableCell>
              <TableCell>{row?.OfferLetterAddedDate?.split("T")[0]}</TableCell>
              <TableCell>{row?.visaReceivedDate?.split("T")[0]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export default ChoiceVerification;
